import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/workspace/frontend/layouts/admin.vue").then(m => m.default || m)),
  client: defineAsyncComponent(() => import("/workspace/frontend/layouts/client.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/workspace/frontend/layouts/default.vue").then(m => m.default || m))
}